import { render, staticRenderFns } from "./big_case.vue?vue&type=template&id=6b73efa8&scoped=true"
import script from "./big_case.vue?vue&type=script&lang=js"
export * from "./big_case.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/case_management.css?vue&type=style&index=0&id=6b73efa8&prod&scoped=true&lang=css&external"
import style1 from "./big_case.vue?vue&type=style&index=1&id=6b73efa8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b73efa8",
  null
  
)

export default component.exports